import { AppRouteProps } from "@mzara/component";
import { ProjectKanbanDetailsDangerContainer } from "./container/ProjectKanbanDetailsDangerContainer";

export const ProjectKanbanDetailsDangerRoutes: Array<AppRouteProps> = [
    {
        path: 'danger',
        element: <ProjectKanbanDetailsDangerContainer />
    }
]